import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { getContent } from '../utils/contentStore';
import { useLanguage } from '../utils/i18n';
export function Catalog() {
  const previewProducts = getContent().previewProducts;
  const products = getContent().products;
  const content = getContent().catalogSection;
  const {
    t,
    loc
  } = useLanguage();
  return <Section id="catalog" data-id="element-33">
      <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6" data-id="element-34">
        <div data-id="element-35">
          <h2 className="text-gray-500 font-bold tracking-widest uppercase mb-3 text-sm" data-id="element-36">
            {loc(content.label)}
          </h2>
          <h3 className="font-heading text-4xl md:text-5xl font-bold text-gray-900 uppercase leading-tight" data-id="element-37">
            {loc(content.title1)}{' '}
            <span className="text-red-600" data-id="element-38">{loc(content.title2)}</span>
          </h3>
        </div>
        <Link to="/catalog" className="hidden md:block" data-id="element-39">
          <Button variant="outline" data-id="element-40">
            {t('catalog_btn_all')} <ArrowRight className="ml-2 h-4 w-4" data-id="element-41" />
          </Button>
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-42">
        {previewProducts.map((previewProduct, index) => {
        // Find the matching full product by name
        const fullProduct = products.find(p => loc(p.name) === loc(previewProduct.name));
        const productLink = fullProduct ? `/catalog/${fullProduct.id}` : '/catalog';
        return <motion.div key={previewProduct.id} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: index * 0.05,
          ease: 'easeOut'
        }} className="group relative bg-white border border-gray-100 rounded-sm overflow-hidden hover:shadow-lg transition-shadow duration-300" data-id="element-43">
              <Link to={productLink} data-id="element-44">
                <div className="aspect-[4/3] overflow-hidden bg-gray-100 relative" data-id="element-45">
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors z-10" data-id="element-46" />
                  <img src={previewProduct.image} alt={loc(previewProduct.name)} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500" data-id="element-47" />

                  <div className="absolute top-4 left-4 z-20" data-id="element-48">
                    <span className="bg-gray-900 text-white text-xs font-bold px-2 py-1 uppercase tracking-wider" data-id="element-49">
                      {loc(previewProduct.category)}
                    </span>
                  </div>
                </div>
                <div className="p-6" data-id="element-50">
                  <h4 className="font-heading text-2xl font-bold text-gray-900 mb-2 group-hover:text-red-600 transition-colors" data-id="element-51">
                    {loc(previewProduct.name)}
                  </h4>
                  <p className="text-gray-600 text-sm mb-6 line-clamp-2" data-id="element-52">
                    {loc(previewProduct.description)}
                  </p>
                  <Button variant="secondary" size="sm" className="w-full" data-id="element-53">
                    {t('catalog_btn_more')}
                  </Button>
                </div>
              </Link>
            </motion.div>;
      })}
      </div>

      <div className="mt-8 text-center md:hidden" data-id="element-54">
        <Link to="/catalog" data-id="element-55">
          <Button variant="outline" className="w-full" data-id="element-56">
            {t('catalog_btn_all')} <ArrowRight className="ml-2 h-4 w-4" data-id="element-57" />
          </Button>
        </Link>
      </div>
    </Section>;
}